import type { ContactFormReportComponentProps } from './ContactFormReportComponent';

export const ContactFormReportComponent = {
    MountAsync: async (target: HTMLElement, props: ContactFormReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ContactFormReportComponent } = await import('./ContactFormReportComponent');
        return await mountReactComponentAsync(target, ContactFormReportComponent, props);
    }
};